<!-- gradelist/GradeInputForm.vue -->
<template>
  <div class="gf-root">
    <el-form :model="grade" ref="gradeform" :rules="rules" label-position="top" size="small">

      <!-- 学校 -->
      <el-form-item label="学校" prop="SchoolName">
        <el-select
          v-model="grade.SchoolName"
          filterable
          placeholder="搜索学校"
          style="width:100%"
          popper-class="school-select-popper"
        >
          <el-option v-for="item in schools" :key="item.ID" :label="item.SchoolName" :value="item.SchoolName">
            <div class="school-option">
              <span class="school-option-name">{{ item.SchoolName }}</span>
              <span class="school-option-country">{{ item.Country }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 专业 + 学历 并排 -->
      <div class="gf-row">
        <el-form-item label="专业" prop="Major" style="flex:1;min-width:0">
          <el-select v-model="grade.Major" filterable placeholder="搜索专业" style="width:100%">
            <el-option v-for="item in majors" :key="item.ID" :label="item.MajorName" :value="item.MajorName" />
          </el-select>
        </el-form-item>

        <el-form-item label="学历" prop="Level" style="width:140px;flex-shrink:0">
          <el-select v-model="grade.Level" placeholder="选择学历" style="width:100%">
            <el-option label="Undergraduate" value="Undergraduate">
              <span class="level-opt level-ug">本科</span>
              <span class="level-opt-en">Undergraduate</span>
            </el-option>
            <el-option label="Master" value="Master">
              <span class="level-opt level-ms">硕士</span>
              <span class="level-opt-en">Master</span>
            </el-option>
            <el-option label="PHD" value="PHD">
              <span class="level-opt level-phd">博士</span>
              <span class="level-opt-en">PHD</span>
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <!-- 入学 + 学年制 并排 -->
      <div class="gf-row">
        <el-form-item label="入学年月" prop="AdmissionDate" style="flex:1;min-width:0">
          <el-date-picker v-model="grade.AdmissionDate" type="month" placeholder="选择入学年月" style="width:100%" />
        </el-form-item>

        <el-form-item label="学年制" prop="TotalYear" style="flex:1;min-width:0">
          <el-select v-model="grade.TotalYear" placeholder="选择学年制" style="width:100%">
            <el-option v-if="['Master'].includes(grade.Level)"                                           label="一年制" :value="1" />
            <el-option v-if="['Master'].includes(grade.Level)"                                           label="两年制" :value="2" />
            <el-option v-if="['Master','Undergraduate'].includes(grade.Level)"                           label="三年制" :value="3" />
            <el-option v-if="['Master','Undergraduate','PHD'].includes(grade.Level)"                     label="四年制" :value="4" />
            <el-option v-if="['Master','Undergraduate','PHD'].includes(grade.Level)"                     label="五年制" :value="5" />
            <el-option v-if="['Master','Undergraduate','PHD'].includes(grade.Level)"                     label="六年制" :value="6" />
            <el-option v-if="['Master','Undergraduate','PHD'].includes(grade.Level)"                     label="七年制" :value="7" />
          </el-select>
        </el-form-item>
      </div>

      <!-- 毕业年月（自动计算，只读展示） -->
      <el-form-item label="预计毕业年月" prop="GraduationDate">
        <div v-if="grade.GraduationDate" class="graduation-preview">
          <span class="graduation-val">{{ new Date(grade.GraduationDate).toLocaleDateString('zh-CN', { year:'numeric', month:'2-digit' }) }}</span>
          <span class="graduation-hint">由入学年月 + 学年制自动计算</span>
        </div>
        <el-date-picker v-else v-model="grade.GraduationDate" type="month" placeholder="或手动选择毕业年月" style="width:100%" />
      </el-form-item>

      <!-- 操作 -->
      <div class="gf-footer">
        <el-button class="btn" @click="$emit('close')">取消</el-button>
        <el-button class="btn btn--green" @click="creategrade">
          <i class="el-icon-check" /> 确认添加
        </el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
export default {
  name: 'GradeInputForm',
  props: {
    isstudent: { default: false }
  },
  data() {
    return {
      rules: {
        SchoolName:     [{ required: true,              message: '请选择学校',    trigger: 'change' }],
        Major:          [{ required: !this.isstudent,   message: '请选择专业',    trigger: 'change' }],
        Level:          [{ required: true,              message: '请选择学历',    trigger: 'change' }],
        AdmissionDate:  [{ required: !this.isstudent,  message: '请选择入学年月', trigger: 'change' }],
        TotalYear:      [{ required: !this.isstudent,  message: '请选择学年制',  trigger: 'change' }],
        GraduationDate: [{ required: !this.isstudent,  message: '请选择毕业年月', trigger: 'change' }]
      },
      grade: {
        TotalYear: null, SchoolName: '',
        AdmissionDate: null, GraduationDate: null,
        Major: '', Level: ''
      },
      schools: [],
      majors:  []
    }
  },
  watch: {
    'grade.TotalYear'(val) {
      if (this.grade.AdmissionDate && val) {
        const d = new Date(this.grade.AdmissionDate)
        d.setFullYear(d.getFullYear() + val)
        this.grade.GraduationDate = d
      }
    },
    'grade.AdmissionDate'(val) {
      if (val && this.grade.TotalYear) {
        const d = new Date(val)
        d.setFullYear(d.getFullYear() + this.grade.TotalYear)
        this.grade.GraduationDate = d
      }
    }
  },
  created() {
    this.$store.dispatch('common/getschoolmajors').then(res => {
      this.schools = res.data.school
      this.majors  = res.data.major
    })
  },
  methods: {
    creategrade() {
      this.$refs.gradeform.validate(valid => {
        if (valid) this.$emit('created', this.grade)
      })
    }
  }
}
</script>

<style scoped>
.gf-root { padding: 4px 0 0; }

/* form */
.gf-root >>> .el-form-item__label {
  font-size: 13px; font-weight: 500; color: #555;
  padding-bottom: 5px; line-height: 1.4;
}
.gf-root >>> .el-form-item { margin-bottom: 16px; }

/* 并排行 */
.gf-row { display: flex; gap: 14px; }

/* 学校下拉选项 */
.school-option { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.school-option-name    { font-size: 13px; color: #1a1a1a; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.school-option-country { font-size: 12px; color: #aaa; white-space: nowrap; flex-shrink: 0; }

/* 学历选项 */
.level-opt {
  display: inline-flex; align-items: center; justify-content: center;
  height: 20px; padding: 0 6px; border-radius: 4px;
  font-size: 11px; font-weight: 500; margin-right: 8px;
}
.level-ug  { background: #E6F1FB; color: #0C447C; }
.level-ms  { background: #EEEDFE; color: #3C3489; }
.level-phd { background: #FAEEDA; color: #633806; }
.level-opt-en { font-size: 12px; color: #aaa; }

/* 毕业预览 */
.graduation-preview {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 12px;
  background: #EAF3DE; border: 0.5px solid #C0DD97; border-radius: 6px;
}
.graduation-val  { font-size: 14px; font-weight: 500; color: #27500A; font-variant-numeric: tabular-nums; }
.graduation-hint { font-size: 11px; color: #639922; }

/* 底部 */
.gf-footer {
  display: flex; justify-content: flex-end; gap: 8px;
  padding-top: 14px; border-top: 0.5px solid rgba(0,0,0,0.07);
}

/* 通用按钮 */
.btn {
  height: 30px !important; padding: 0 14px !important;
  border-radius: 6px !important; font-size: 13px !important;
  border: 0.5px solid rgba(0,0,0,0.1) !important;
  background: #fff !important; color: #555 !important;
  display: inline-flex !important; align-items: center !important; gap: 4px !important;
}
.btn:hover        { background: #f5f5f5 !important; }
.btn--green       { background: #EAF3DE !important; border-color: #C0DD97 !important; color: #27500A !important; }
.btn--green:hover { background: #d4ecbe !important; }
</style>

<style>
.school-select-popper {
  max-width: 420px !important;
}
.school-select-popper .el-select-dropdown__item {
  padding: 0 12px;
  height: 36px;
  line-height: 36px;
}
.school-select-popper .school-option-name {
  font-size: 12px;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 5000px;
  display: inline-block;
}
.school-select-popper .school-option-country {
  font-size: 11px;
  color: #bbb;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>